import React, { useEffect, useState } from "react";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";

import { doService } from "../../../services/ServiceHelper";
import { getSchoolStudents } from "../../../services/UserService";

function StudentSelector({ school, jwt, onChange }) {
  const [_letters, setLetters] = useState([]);
  const [_students, setStudents] = useState([]);
  const [_allStudents, setAllStudents] = useState([]);
  const [_studentMap, setStudentMap] = useState({});

  const [_selectedStudentEid, setSelectedStudentEid] = React.useState("XX");
  const [_selectedLetter, setSelectedLetter] = useState("XX");

  useEffect(() => {
    const letters = initLetters();
    initStudents(letters);
  }, []);

  const initStudents = (letters) => {
    doService(getSchoolStudents(school, jwt), (results) => {
      setAllStudents(results.data);

      // initially set drop list to all students, until they select a letter
      setStudents(results.data);

      // init map with letter keys
      const map = {};
      for (const letter of letters) {
        map[letter] = [];
      }

      // put students in buckets
      for (let student of results.data) {
        const studentLetter = student.last_name
          .trim()
          .toUpperCase()
          .substring(0, 1);
        if (map[studentLetter]) {
          map[studentLetter].push(student);
        }
      }

      setStudentMap(map);
    });
  };

  const initLetters = () => {
    // Using for loop for (A-Z):
    const letters = [];
    const letters2 = [];

    letters.push({
      label: "--",
      value: "XX",
    });
    for (let i = 65; i <= 90; i++) {
      const letter = String.fromCharCode(i);
      letters2.push(letter);
      letters.push({
        label: letter,
        value: letter,
      });
    }
    setLetters(letters);
    return letters2;
  };

  const handleChangeLetter = (event) => {
    setSelectedLetter(event.target.value);

    if (event.target.value === "XX") {
      setStudents(_allStudents);
    } else {
      setStudents(_studentMap[event.target.value]);
    }

    const studentEvent = {
      target: {
        value: "XX",
      },
    };
    handleChangeStudent(studentEvent);
  };
  const handleChangeStudent = (event) => {
    setSelectedStudentEid(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <>
      <Grid container sx={{mt:0, pt:0}}>
        <Grid item xs={3} sx={{mt:0, pt:0}}>
          <Select sx={{mt:0, pt:0}}
            fullWidth
            size="small"
            onChange={handleChangeLetter}
            value={_selectedLetter}
          >
            {_letters.map((letter, i) => (
              <MenuItem key={i + 1} value={letter.value}>
                {letter.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={9}>
          <Select
            size="small"
            onChange={handleChangeStudent}
            value={_selectedStudentEid}
            sx={{ml:1}}
            disabled={_selectedLetter === "XX"}
          >
            <MenuItem key="XX" value="XX">
              -- SELECT STUDENT --
            </MenuItem>
            {_students.map((student) => (
              <MenuItem key={student.eid} value={student.eid}>
                {student.last_name}, {student.first_name} ({student.grade})
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    </>
  );
}

export default StudentSelector;
